import { render, staticRenderFns } from "./AnnouncementDelete.vue?vue&type=template&id=3fe37908"
import script from "./AnnouncementDelete.vue?vue&type=script&lang=js"
export * from "./AnnouncementDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports